import React from "react";
import { Row, Col } from "reactstrap";

const TablePagination = ({ table }) => {
  // table nesnesinden gerekli method ve state'leri alalım
  const {
    getCanPreviousPage,
    getCanNextPage,
    getPageOptions,
    setPageIndex,
    nextPage,
    previousPage,
    getState,
    getFilteredRowModel,
  } = table;

  const { pageIndex, pageSize } = getState().pagination;
  const totalRows = getFilteredRowModel().rows.length;

  // Eğer gösterilecek hiç satır yoksa, pagination'ı hiç gösterme
  if (totalRows === 0) {
    return null;
  }

  return (
    <Row className="align-items-center mt-2 g-3 text-center text-sm-start">
      {/* "Showing X to Y of Z" metni */}
      <Col sm>
        <div className="text-muted">
          Toplam {totalRows} kayıttan {pageIndex * pageSize + 1}
          &nbsp;ile {Math.min((pageIndex + 1) * pageSize, totalRows)} arası
          gösteriliyor
        </div>
      </Col>

      {/* Sayfa butonları */}
      <Col sm="auto">
        <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
          <li
            className={
              !getCanPreviousPage() ? "page-item disabled" : "page-item"
            }
          >
            <button className="page-link" onClick={previousPage}>
              {"<"}
            </button>
          </li>

          {getPageOptions().map((item, key) => {
            const totalPages = getPageOptions().length;
            const firstPage = item === 0;
            const lastPage = item === totalPages - 1;
            const nearCurrentPage = Math.abs(pageIndex - item) <= 1;
            const shouldShowEllipsisBefore = item === 1 && pageIndex > 2;
            const shouldShowEllipsisAfter =
              item === totalPages - 2 && pageIndex < totalPages - 3;

            if (shouldShowEllipsisBefore || shouldShowEllipsisAfter) {
              // Daha iyi bir UX için "..." ekleyebilirsiniz
              if (shouldShowEllipsisBefore && key === 2 && pageIndex > 2) {
                return (
                  <li key="start-ellipsis" className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                );
              }
              if (
                shouldShowEllipsisAfter &&
                key === totalPages - 3 &&
                pageIndex < totalPages - 3
              ) {
                return (
                  <li key="end-ellipsis" className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                );
              }
            }

            if (firstPage || lastPage || nearCurrentPage) {
              return (
                <li key={key} className="page-item">
                  <button
                    className={
                      pageIndex === item ? "page-link active" : "page-link"
                    }
                    onClick={() => setPageIndex(item)}
                  >
                    {item + 1}
                  </button>
                </li>
              );
            }
            return null;
          })}

          <li
            className={!getCanNextPage() ? "page-item disabled" : "page-item"}
          >
            <button className="page-link" onClick={nextPage}>
              {">"}
            </button>
          </li>
        </ul>
      </Col>
    </Row>
  );
};

export default TablePagination;
